import { Component, OnInit } from '@angular/core';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-game-glossary',
  templateUrl: './game-glossary.component.html',
  styleUrls: ['./game-glossary.component.scss']
})
export class GameGlossaryComponent implements OnInit {

  url: any;
  title: any;
  category: any;
  search: string = '';
  glosary: any = [];
  areas: any = [];
  ready: boolean = false;
  private routeObs: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public api: RestapiService
  ) {
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.category = this.activatedRoute.snapshot.paramMap.get('category');
        //this.loadContent(this.pag.firstPage);
      }, 10);
    });
  }

  ngOnInit(): void {
    this.category = this.activatedRoute.snapshot.paramMap.get('category');
    /* this.api.getdata('websection', { filters: { webroute_id: { value: 9 } } })
    .subscribe(res=>{
      this.areas = res.result.data;
      console.log('secciones', this.areas);
    }) */

    this.url = this.activatedRoute.snapshot.paramMap.get('game');
    switch (this.url) {
      case 'incendios-forestales':
        this.title = 'Incendios Forestales';
        this.api.getdata('websection', { filters: {
          webroute_id: { value: 9 } ,
          webcontext_id: { value: 12 } ,
        } })
        .subscribe(res=>{
          this.areas = res.result.data;
          console.log('secciones', this.areas);
        })
        break;
      case 'humedales':
        this.title = 'Humedales';
        this.api.getdata('websection', { filters: {
          webroute_id: { value: 9 } ,
          webcontext_id: { value: 13 } ,
        } })
        .subscribe(res=>{
          this.areas = res.result.data;
          console.log('secciones', this.areas);
        })
        break;
    }
  }

  onchange(event: any) {
    console.log('onchange', event.target.value);
    this.search = event.target.value;
    this.loadContent();
  }

  reset(){
    this.search = '';
    console.log('resetead',this.search)
  }

  loadContent(nextPage?: any) {
    // this.page++;

    this.ready = false;
    this.glosary = [];
    this.api.getdata('webglossary', {
      page: 1,
      per_page: 100,
      filters: {
        // webcollection_id: {value: 3},
        name: { value: this.search, operator: 'like' },
        //   title: { value: this.collection == 'Ficha-digital' ? this.search : '', operator: 'like' },
        // webcontext_id: { model: 'webcontext', value: (this.context != 'todos') ? this.context : '', field: 'name', operator: 'belongsTo' },
        //  webcollection_id: { model: 'webcollection', value: this.collection, field: 'name', operator: 'belongsTo' }
      },
    }).subscribe(res => {
      console.log('BLOG webglossary', res);
      if (res.status == true) {
        if (res.result.data.length > 0) {
          this.glosary = res.result.data;
          console.log('BLOG LOADED', this.glosary)
        }
      }
      this.ready = true;
    })
  }

}
